<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <ul class="list-none m-0 p-0">
      <li class="px-0 py-2 flex justify-between">Order #1001 <span class="text-success">Fullfilled</span></li>
      <li class="px-0 py-2 flex justify-between">Order #1002 <span class="text-info">In Progress</span></li>
      <li class="px-0 py-2 flex justify-between">
        Order #1003 <span class="text-warning">Waiting payment</span>
      </li>
    </ul>
  </DashboardWidgetBase>
</template>
